import * as React from "react";
import * as React44ms from "../../../Util/form-utils/react-44ms";

import { InputContainer2023, InputContainer2023Props } from "./input-container";

export interface CheckboxInput2023Expects {
  value: boolean;
  error?: string;
  required?: boolean;
}

export interface CheckboxInput2023Props
  extends Omit<InputContainer2023Props, "name"> {
  id: string;
  onChange: (
    formRef: React44ms.Api.TypedRef<CheckboxInput2023Expects>,
    newValue: CheckboxInput2023Expects["value"]
  ) => void;
  formRef: React44ms.Api.TypedRef<CheckboxInput2023Expects>;
}

export const CheckboxInput2023: React.FunctionComponent<
  CheckboxInput2023Props
> = (props) => {
  const [formState] = React44ms.React.useForm(props.formRef);
  const { value, error, required } = formState || {};
  const isChecked = !!value;

  const name = React.useMemo(() => {
    return React44ms.React.Presentation.elements.nameFromRef(props.formRef);
  }, [props.formRef]);

  if (!name) {
    return null;
  }

  return (
    <InputContainer2023
      {...props}
      name={name}
      errorValueIfAny={error}
      required={!!required}
      className="checkbox-input"
    >
      <div
        className={`input-immediate-container ${
          isChecked ? "checked" : "unchecked"
        }`}
      >
        <input
          type="checkbox"
          id={props.id}
          name={name}
          checked={isChecked}
          onChange={(event) =>
            props.onChange(props.formRef, event.target.checked)
          }
          required={!!required}
        />
        <label htmlFor={props.id} className="name">
          {props.children}
        </label>
      </div>
    </InputContainer2023>
  );
};
